import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.25 10V7a5.75 5.75 0 1 1 11.5 0v3h2.028c1.227 0 2.222.977 2.222 2.182v7.636C22 21.023 21.005 22 19.778 22H4.222C2.995 22 2 21.023 2 19.818v-7.636C2 10.977 2.995 10 4.222 10zm2.745-6.005A4.25 4.25 0 0 1 16.25 7v3h-8.5V7a4.25 4.25 0 0 1 1.245-3.005M3.5 12.182c0-.35.297-.682.722-.682h15.556c.425 0 .722.331.722.682v7.636c0 .35-.297.682-.722.682H4.222c-.425 0-.722-.331-.722-.682z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }